import React, { useRef } from 'react';
import { Box } from '@components/Box';
import { aboutPageData } from '@data-ts/pages/about';
import { Flex } from '@components/Flex';
import { PhotoTextContainer, StyledImageContainer, StyledImageWrapper } from './PhotoCollection.styles';
import { useThemeMediaQuery } from '@hooks/useThemeMediaQuery';
interface PhotoCollectionSectionProps
  extends Readonly<{
    photos: ReadonlyArray<string>;
  }> {}

const imagesInfo = [
  { width: 310, height: 400, mobileWidth: 110, mobileHeight: 160 },
  { width: 310, height: 300, mobileWidth: 110, mobileHeight: 160 },
  { width: 340, height: 350, mobileWidth: 110, mobileHeight: 160 },
  { width: 563, height: 500, mobileWidth: 220, mobileHeight: 195 },
  { width: 563, height: 400, mobileWidth: 220, mobileHeight: 149 },
  { width: 352, height: 295, mobileWidth: 110, mobileHeight: 160 },
  { width: 351, height: 360, mobileWidth: 110, mobileHeight: 160 },
  { width: 258, height: 300, mobileWidth: 110, mobileHeight: 160 },
  { width: 99, height: 300, mobileWidth: 0, mobileHeight: 0 },
  { width: 350, height: 560, mobileWidth: 0, mobileHeight: 0 },
  { width: 333, height: 272, mobileWidth: 0, mobileHeight: 0 },
];

export const PhotoCollectionSection: React.FC<PhotoCollectionSectionProps> = ({ photos }) => {
  const isMobile = useThemeMediaQuery('below_sm');
  const { photoCollectionData } = aboutPageData;
  return (
    <Box backgroundColor="humana1" paddingY={[10]}>
      <Flex justifyContent="center" paddingX={[6, 0]} marginBottom={[10]}>
        <PhotoTextContainer variant="hed40" tagName="h2" textAlign="center" color="neutra6">
          {photoCollectionData.title}
        </PhotoTextContainer>
      </Flex>
      <Flex>
        <Box marginLeft={[0, 0]}>
          {[0, 1, 2].map(item => (
            <StyledImageWrapper
              key={item}
              width={isMobile ? imagesInfo[item].mobileWidth : imagesInfo[item].width}
              height={isMobile ? imagesInfo[item].mobileHeight : imagesInfo[item].height}
              margin={[2, 4]}
              marginLeft={item === 2 ? [-8, -13, -10] : [-8, -12, -2]}
              backgroundColor="humana3"
              padding={[0, 4]}
            >
              <StyledImageContainer isEagerLoading src={photos[item]} alt={photoCollectionData.altText} width="97%" height="95%" />
            </StyledImageWrapper>
          ))}
        </Box>
        <Box paddingTop={[9, 12]}>
          {[3, 4].map(item => (
            <StyledImageWrapper
              key={item}
              width={isMobile ? imagesInfo[item].mobileWidth : imagesInfo[item].width}
              height={isMobile ? imagesInfo[item].mobileHeight : imagesInfo[item].height}
              margin={[2, 4]}
              backgroundColor="humana3"
              padding={[2, 4]}
            >
              <StyledImageContainer
                isEagerLoading
                objectFit={'contain'}
                src={photos[item]}
                alt={photoCollectionData.altText}
                width="97%"
                height="95%"
              />
            </StyledImageWrapper>
          ))}
        </Box>
        <Box paddingTop={[0, 10]}>
          {[5, 6, 7].map(item => {
            if (item !== 7) {
              return (
                <StyledImageWrapper
                  key={item}
                  width={isMobile ? imagesInfo[item].mobileWidth : imagesInfo[item].width}
                  height={isMobile ? imagesInfo[item].mobileHeight : imagesInfo[item].height}
                  margin={[4, 4]}
                  backgroundColor="humana3"
                  padding={[2, 4]}
                >
                  <StyledImageContainer
                    isEagerLoading
                    objectFit="contain"
                    src={photos[item]}
                    alt={photoCollectionData.altText}
                    width="97%"
                    height="95%"
                  />
                </StyledImageWrapper>
              );
            }
            return (
              <Flex key={'row70'}>
                <StyledImageWrapper
                  key={`row71`}
                  width={isMobile ? imagesInfo[item].mobileWidth : imagesInfo[item].width}
                  height={isMobile ? imagesInfo[item].mobileHeight : imagesInfo[item].height}
                  margin={[4, 4]}
                  backgroundColor="humana3"
                  padding={[2, 4]}
                >
                  <StyledImageContainer
                    isEagerLoading
                    objectFit="contain"
                    src={photos[item]}
                    alt={photoCollectionData.altText}
                    width="97%"
                    height="95%"
                  />
                </StyledImageWrapper>
                <StyledImageWrapper
                  key={`row72`}
                  width={isMobile ? imagesInfo[item + 1].mobileWidth : imagesInfo[item + 1].width}
                  height={isMobile ? imagesInfo[item + 1].mobileHeight : imagesInfo[item + 1].height}
                  margin={[4, 4]}
                  backgroundColor="humana3"
                  padding={[2, 0]}
                >
                  <StyledImageContainer
                    isEagerLoading
                    objectFit="contain"
                    src={photos[item + 1]}
                    alt={photoCollectionData.altText}
                    width="97%"
                    height="90%"
                  />
                </StyledImageWrapper>
              </Flex>
            );
          })}
        </Box>
        <Box>
          {[9, 10].map(item => (
            <StyledImageWrapper
              key={item}
              width={isMobile ? imagesInfo[item].mobileWidth : imagesInfo[item].width}
              height={isMobile ? imagesInfo[item].mobileHeight : imagesInfo[item].height}
              margin={[0, 4]}
              backgroundColor="humana3"
              padding={[0, 4]}
            >
              <StyledImageContainer
                isEagerLoading
                objectFit={item == 9 ? 'contain' : 'center'}
                src={photos[item]}
                alt={photoCollectionData.altText}
                width="97%"
                height="95%"
              />
            </StyledImageWrapper>
          ))}
        </Box>
      </Flex>
    </Box>
  );
};
